/** Claves alineadas con `gestionPermissions` del backend (`/auth/me`, login). */
export const BANDA_ACCOUNT_TYPES = ['BANDA', 'BANDA_COLABORADOR'];

export function isBandaAccountUserType(userType) {
  return userType === 'BANDA' || userType === 'BANDA_COLABORADOR';
}

export function canAccessGestionModule(user, permissionKey) {
  if (!user) return false;
  if (user.userType === 'BANDA') return true;
  if (user.userType !== 'BANDA_COLABORADOR') return false;
  return Boolean(user.gestionPermissions?.[permissionKey]);
}

/** Ruta de perfil con pestaña Tu web (solo banda). */
export const BANDA_TU_WEB_TAB_PATH = '/banda/perfil?tab=tuweb';

export function canAccessTuWeb(user) {
  if (!user) return false;
  if (user.userType === 'BANDA') return true;
  if (user.userType === 'BANDA_COLABORADOR') return Boolean(user.gestionPermissions?.tuWeb);
  return false;
}

const COLAB_GESTION_ORDER = [
  ['repertorio', '/banda/repertorio'],
  ['musicos', '/banda/musicos'],
  ['formaciones', '/banda/formaciones'],
  ['actuaciones', '/banda/actuaciones'],
  ['ensayos', '/banda/ensayos'],
  ['documentos', '/banda/documentos'],
  ['contactos', '/banda/contactos'],
  ['estadisticas', '/banda/metricas'],
  ['objetivos', '/banda/objetivos'],
  ['encuestas', '/banda/encuestas-consultas'],
];

/** Primera sección de Gestión permitida para un colaborador, o null. */
export function firstColaboradorGestionPath(user) {
  if (!user || user.userType !== 'BANDA_COLABORADOR' || !user.gestionPermissions) return null;
  for (const [key, path] of COLAB_GESTION_ORDER) {
    if (user.gestionPermissions[key]) return path;
  }
  return null;
}
